/**
 * Not Found Page (404)
 */

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SearchOff as NotFoundIcon } from "@mui/icons-material";
import { useAuthStore } from "@/store/authStore";
import { homePathForRole } from "@/utils/homePath";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuthStore();

  const getDashboardPath = () => {
    if (!isAuthenticated) return "/login";
    return homePathForRole(user?.role);
  };

  const dashboardLabel = isAuthenticated ? "Go to Dashboard" : "Go to Login";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
        p: 3,
      }}
    >
      <NotFoundIcon sx={{ fontSize: 100, color: "text.disabled", mb: 3 }} />
      <Typography variant="h3" gutterBottom sx={{
        fontWeight: 700
      }}>
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          textAlign: "center",
          mb: 4,
          maxWidth: 480
        }}>
        The page you're looking for doesn't exist or may have been moved.
        <br />
        Check the URL or navigate back to your dashboard.
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
        <Button variant="contained" onClick={() => navigate(getDashboardPath())}>
          {dashboardLabel}
        </Button>
      </Box>
    </Box>
  );
};
